module.exports = __webpack_public_path__ + "img/certificate_1.22100673.jpeg";